if($('#grow-together-quotes').length){
  //- init slider
  function initSlider(){
    var quote = [];
    //- force jquery to use flex with fade/transition functions
    clearSlider();
    $('#grow-together-quotes .quote:first-of-type').show();
    $('#grow-together-quotes .quote-logo:first-of-type').show();
    //- populate quote array with comments WP ID
    $('#grow-together-quotes .quote').each(function () {
      var id = $(this).attr("data-quote-id");
      quote.push(id);
    });
    return quote;
  }
  if ($('#grow-together-quotes').length) {
    var quote = initSlider();
    currentCommentID = $("#grow-together-quotes .quote:visible").attr("data-quote-id").toString();
  }

  //- clear slider
  function clearSlider(){
    $("#grow-together-quotes .quote").each(function() {
      var id = $(this).attr("data-quote-id");
      $("#grow-together-quotes #logo-" + id).hide();
      $(this).hide();
    });
  }
  //- prev / next nav
  function updateSlider(commentID) {
    $("#grow-together-quotes #quote-" + commentID).fadeIn('slow');
    $("#grow-together-quotes #logo-" + commentID).fadeIn('slow');
  }

  $("#grow-together-quotes .next").on('click', function (e) {
    e.preventDefault();
    var nextIndex = quote.indexOf(currentCommentID) + 1;
    nextCommentID = nextIndex < quote.length ? quote[nextIndex] : quote[0];
    clearSlider();
    updateSlider(nextCommentID);
    currentCommentID = nextCommentID;
  });
  $("#grow-together-quotes .prev").on('click', function (e) {
    e.preventDefault();
    var prevIndex = quote.indexOf(currentCommentID) - 1;
    prevCommentID = prevIndex >= 0 ? quote[prevIndex] : quote[quote.length-1];
    clearSlider();
    updateSlider(prevCommentID);
    currentCommentID = prevCommentID;
  });

}
